import React, { ReactNode } from "react"
import { Grid2 } from "@mui/material"

import useStyles from "@/components/Sidebar/Footer/styles"

type FooterProps = {
	children: ReactNode
}

export const Footer = (props: FooterProps) => {
	const { children } = props
	const classes = useStyles()

	return (
		<Grid2 size={12}>
			<Grid2 container direction="column" alignItems="flex-start" sx={classes.footer}>
				{children}
			</Grid2>
		</Grid2>
	)
}
